import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'tr',
    fallbackLng: 'tr',
    supportedLngs: ['tr', 'en', 'de'],
    debug: false,
    resources: messages,
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'dorukdental_language',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
